// Generator-discovered file route for the ad-platform home. The substantive
// component lives in `src/ad/routes/index.tsx` (Module K / K3) — this thin shim
// only registers it in the TanStack route tree under `/_authenticated/ad/`.
import { createFileRoute } from '@tanstack/react-router';
import { AdIndexRouteComponent } from '@/ad/routes/index';

export const Route = createFileRoute('/_authenticated/ad/')({
  component: AdIndexRouteComponent,
});
